import { Config } from 'utils';

function url(service) {
	return Config.apiUrl + service;
}

class Api {

	get(service, params, callback) {
		return $.get(url(service), params, callback, 'json');
	}

	post(service, params, callback) {
		return $.ajax({
			type: 'POST',
			dataType: 'json',
			contentType: "application/json; charset=utf-8",
			data: JSON.stringify(params),
			cache: false,
			url: url(service),
			success: callback
		})
	}
}

const api = new Api();
export default api;


// WEBPACK FOOTER //
// ./src/modules/app/Api.js